export default __webpack_public_path__ + "static/media/googlemap.89ee6659.jpeg";